import {
  ApiServiceHandler,
  AuthenticationHandler,
  Interceptor,
  UseService,
} from "@haskoning/js-api-authentication-management";
import { loginRequest, msalInstance } from "@/msalAuthConfig";
import { InteractionType } from "@azure/msal-browser";
import { ensureAuthenticated } from "@haskoning/msal";

export const useApi = (baseURL: string) => {
  const authenticationHandler = new AuthenticationHandler(
    baseURL,
    `api/token/`,
    `api/token/refresh/`,
    "access",
    "refresh_token",
    null,
    "Authorization",
    "Bearer",
    true,
    true,
    () => ensureAuthenticated(msalInstance, InteractionType.Popup, loginRequest)
  );

  const apiServiceHandler = new ApiServiceHandler(
    baseURL,
    `api/token/`, // Dummy not being used
    `api/token/refresh/`, // Dummy not being used
    new Interceptor(),
    "access",
    "refresh_token",
    authenticationHandler
  );

  return new UseService(apiServiceHandler);
};
